import { useInfiniteQuery as useReactInfiniteQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { toast } from "Layout/slice";
import { parseErrorMessage } from "utils";

export const useInfiniteQuery = ({
  key = "data",
  queryKey = ["data"],
  queryFn = () => {},
  onError,
  getNextPageParam = () => {},
  refetchOnMount = "if-stale",
  enabled = true,
}) => {
  const dispatch = useDispatch();

  const handleError = useCallback(
    (error) => {
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );

      if (onError) onError(error);
    },
    [dispatch, onError]
  );

  const {
    isLoading,
    isFetching,
    isSuccess,
    isStale,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    data,
    refetch,
    isError,
    error,
  } = useReactInfiniteQuery({
    queryKey: queryKey ? queryKey : [key],
    queryFn,
    getNextPageParam,
    refetchOnMount,
    throwOnError: false,
    onError: handleError,
    enabled,
  });

  return {
    isLoading,
    isFetching,
    isSuccess,
    isError,
    isStale,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    data,
    refetch,
    error,
  };
};
